import styled from "styled-components"
import { Button as DefaultButton } from "../../button/button"

export const Container = styled.div`
  background-color: #DCFFF8;
  padding: 80px 0px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;
  }
`

export const ContainerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
  `

export const TitleContainer = styled.h4`
  align-items: center;
  display: flex;
  flex: 1 100%;
  justify-content: center;
`

export const Title = styled.h3`
  color: #00A687;

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 36.77px;
  }
`

export const Form = styled.form`
  display: flex;
  flex: 1 100%;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 24px;
  }
`

export const Button = styled(DefaultButton)`
  font-family: Ubuntu;
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  margin-top: 16px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  width: 75%;
`